<template>
    <section class="container-fluid">
        <h1>{{ $t('wealth') }}</h1>
        <wealth-levels></wealth-levels>
    </section>
</template>

<script>
import WealthLevels from '@/components/WealthLevels';
export default {
    components: {
        WealthLevels
    }
};
</script>
